import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { useNavigate } from 'react-router';

import { Grid, Dialog, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
// import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import './modalDatosIniciales.css';

// import { AutocompleteCustomers } from './AutocompleteCustomers';
import { budgetsUpdateDatosInicialesNotSave } from '../../../redux/actions/pptos';
// import { toast } from 'react-toastify';
// import { AutocompleteRelacionados } from './AutocompleteRelacionados';
// import { verifyRules } from '../../../helpers/pptosProfits';
// import { DialogProfileContact } from '../../contactos/DialogProfileContact';
// import { Contacts } from '../../contactos/model';
// import NumberFormat from 'react-number-format';
import { AutocompleteProjects } from './AutocompleteProjects';
// import { Model } from '../../../models/model';

export const PptosDialogLinkProjects = ({ open, setOpen }) => {

    const dispatch = useDispatch()
    // const navigate = useNavigate()

    const detailBudget = useSelector(state => state.ppto.detail)
    const { id_proyecto, nombre_proyecto } = detailBudget

    const [form, setForm] = useState({
        id_proyecto: id_proyecto,
        nombre_proyecto: nombre_proyecto
    })

    const handleChange = (e, selectedProject) => {
        setForm({
            ...form,
            id_proyecto: selectedProject?.id,
            nombre_proyecto: selectedProject?.nombre
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        const newDetail = {
            ...detailBudget,
            id_proyecto: form.id_proyecto,
            nombre_proyecto: form.nombre_proyecto
        }

        dispatch(budgetsUpdateDatosInicialesNotSave(newDetail))

        setOpen(false)
    }

    return (
        <Dialog
            className='dialogoCrearPresupuesto'
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
        >
            <div className='ContainerDialogs'>

                <h1 className='TitleModalPresupuesto'>
                    Proyecto asociado
                    <IconButton
                        style={{ padding: '0', float: 'right' }}
                        aria-label="close"
                        onClick={() => setOpen(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                </h1>

                <form onSubmit={handleSubmit} style={{ marginTop: '30px' }}>

                    <Grid container>
                        <Grid item xs={12}>
                            <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>
                                <Grid item xs={12}>
                                    <AutocompleteProjects
                                        form={form}
                                        handleChange={handleChange}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <div style={{ marginTop: '27px', textAlign: 'right' }}>
                        <Button
                            id="id-button-save-ppto"
                            className='p-btn-primary'
                            variant="contained"
                            size='medium'
                            type='submit'
                        >
                            Asociar
                        </Button>
                    </div>

                </form>

            </div>
        </Dialog>
    )
}
